/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import {
  DEFAULT_ENTRA_REDIRECT_PATH,
  hasAuthResponseInUrl,
  isChildBrowsingContext,
  isSameAppPath,
} from './shared/auth/auth-settings';
import { preloadAppSettings } from './shared/runtime-settings';
import { showStartupError } from './shared/startup-error';

/**
 * The MSAL redirect bridge must run without Angular or an MSAL instance, so the application
 * bundle is loaded only through a dynamic import once the bridge case has been ruled out.
 */
async function start(): Promise<void> {
  // An MSAL hidden iframe or popup returning to the default redirect URI: hand the response over and stop.
  // The path check keeps an MMP page in a frame with unrelated code/state parameters loading.
  if (isChildBrowsingContext() && hasAuthResponseInUrl(window.location)
    && isSameAppPath(window.location.pathname, DEFAULT_ENTRA_REDIRECT_PATH)) {
    const bridge = await import('./redirect-bridge');
    await bridge.runRedirectBridge();
    return;
  }

  const settings = await preloadAppSettings();
  const bridgePath = settings?.entraRedirectPath?.trim() || DEFAULT_ENTRA_REDIRECT_PATH;
  if (settings && isSameAppPath(window.location.pathname, bridgePath)) {
    const bridge = await import('./redirect-bridge');
    await bridge.runRedirectBridge();
    return;
  }

  const app = await import('./app-bootstrap');
  await app.bootstrapApplication(settings);
}

if (typeof window !== 'undefined') {
  start().catch(err => {
    // Sentry is not initialized yet at this point (it needs the loaded settings), so show the failure.
    console.error(err);
    showStartupError('MMP could not be loaded. Please refresh the page or contact support.');
  });
}

export { renderModule } from '@angular/platform-server';
